import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import LocationField from '@shared/fields/location-field';
import EmailsField from '@shared/fields/emails-field';
import JsonField from '@shared/fields/json-field';
import { CoachField } from '@modules/coach/coach-field';
import { SubprogramField } from '@modules/subprogram/subprogram-field';

function label(name) {
  return i18n(`entities.school.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), { "required": true}),
  location: new LocationField('location', label('location'), { "required": true}),
  emails: new EmailsField('emails', label('emails')),
  //coaches: new JsonField('coaches', label('coaches')),
  subprograms: SubprogramField.relationToOne('subprograms', label('categories')),
  coaches: CoachField.relationToOne('coaches', label('coaches')),
  teams: new JsonField('teams', label('teams')),
  createdAt: new DateTimeField( 'createdAt', label('createdAt')),
  updatedAt: new DateTimeField( 'updatedAt', label('updatedAt')),
  createdAtRange: new DateTimeRangeField('createdAtRange',label('createdAtRange')),
};

export class SchoolModel extends GenericModel {
  static get fields() {
    return fields;
  }
}